import{isNode as So}from"@binance/w3w-utils";import*as h from"react";import{createRoot as zn}from"react-dom/client";var C=`.pointer-events-auto {
  pointer-events: auto;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.bottom-0 {
  bottom: 0px;
}

.left-0 {
  left: 0px;
}

.top-0 {
  top: 0px;
}

.top-2\\/4 {
  top: 50%;
}

.m-auto {
  margin: auto;
}

.mx-\\[4px\\] {
  margin-left: 4px;
  margin-right: 4px;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.ml-1 {
  margin-left: 0.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-\\[35px\\] {
  margin-top: 35px;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.h-\\[200px\\] {
  height: 200px;
}

.h-\\[24px\\] {
  height: 24px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-\\[52px\\] {
  height: 52px;
}

.h-full {
  height: 100%;
}

.w-\\[150px\\] {
  width: 150px;
}

.w-\\[200px\\] {
  width: 200px;
}

.w-\\[20px\\] {
  width: 20px;
}

.w-\\[24px\\] {
  width: 24px;
}

.w-\\[343px\\] {
  width: 343px;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[75px\\] {
  width: 75px;
}

.w-full {
  width: 100%;
}

.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.grid-flow-col {
  grid-auto-flow: column;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.items-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

.gap-y-2 {
  row-gap: 0.5rem;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.border {
  border-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.bg-black\\/\\[\\.80\\] {
  background-color: rgb(0 0 0 / .80);
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.p-\\[12px\\] {
  padding: 12px;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pt-\\[20px\\] {
  padding-top: 20px;
}

.text-center {
  text-align: center;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.font-medium {
  font-weight: 500;
}

.text-\\[\\#1E2329\\] {
  --tw-text-opacity: 1;
  color: rgb(30 35 41 / var(--tw-text-opacity));
}

.text-\\[\\#929AA5\\] {
  --tw-text-opacity: 1;
  color: rgb(146 154 165 / var(--tw-text-opacity));
}

.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.duration-300 {
  transition-duration: 300ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.will-change-auto {
  will-change: auto;
}

.will-change-transform {
  will-change: transform;
}

.body3 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.subtitle1 {
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.subtitle3 {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 150% */
}

.caption2 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.t-black {
  color: #0b0e11;
}

.t-brand {
  color: #c99400;
}

.t-primary {
  color: #202630;
}

.t-secondary {
  color: #474d57;
}

.bg-primary {
  background: #fcd535;
}

@media (min-width: 768px) {
  .md\\:subtitle1 {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:font-semibold {
    font-weight: 600;
  }
}

@media (min-width: 1024px) {
  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
`;var A=`
${C}
*, :before, :after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / .5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}
:root {
  --animation-duration: 300ms;
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.animated {
  animation-duration: var(--animation-duration);
  animation-fill-mode: both;
}

.fadeIn {
  animation-name: fadeIn;
}

.fadeOut {
  animation-name: fadeOut;
}

#binanceW3W-wrapper {
  -webkit-user-select: none;
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  user-select: none;
  width: 100%;
  z-index: 99999999999999;
}
`;import{createContext as Oo,useContext as Eo}from"react";var x=Oo({}),I=()=>Eo(x);import{openBinanceDeepLink as Tn}from"@binance/w3w-utils";import c,{useEffect as On,useState as bo}from"react";var b="binanceW3W-wrapper";var p="binanceW3W-qrcode-modal",v={googlePlay:"https://app.appsflyer.com/com.binance.dev?pid=https%3A%2F%2Fwww.binance.com%2Fen&c=https%3A%2F%2Fwww.binance.com%2Fen",appleStore:"https://app.appsflyer.com/id1436799971?pid=https%3A%2F%2Fwww.binance.com%2Fen&c=https%3A%2F%2Fwww.binance.com%2Fen"},Po="PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjUyIiBoZWlnaHQ9IjUyIiByeD0iMTAiIGZpbGw9IiMxNDE1MUEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTIgMjhMMTUuNjEyOSAyNC4zODcxTDE5LjIyNTggMjhMMTUuNjEyOSAzMS42MTI5TDEyIDI4WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMTguMTkzNSAyMS44MDY1TDI4IDEyTDM3LjgwNjUgMjEuODA2NUwzNC4xOTM2IDI1LjQxOTRMMjggMTkuMjI1OEwyMS44MDY1IDI1LjQxOTRMMTguMTkzNSAyMS44MDY1WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMjQuMzg3MSAyOEwyOCAyNC4zODcxTDMxLjYxMjkgMjhMMjggMzEuNjEyOUwyNC4zODcxIDI4WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMjEuODA2NSAzMC41ODA2TDE4LjE5MzUgMzQuMTkzNUwyOCA0NEwzNy44MDY1IDM0LjE5MzVMMzQuMTkzNiAzMC41ODA2TDI4IDM2Ljc3NDJMMjEuODA2NSAzMC41ODA2WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNMzYuNzc0MiAyOEw0MC4zODcxIDI0LjM4NzFMNDQgMjhMNDAuMzg3MSAzMS42MTI5TDM2Ljc3NDIgMjhaIiBmaWxsPSIjRjBCOTBCIi8+Cjwvc3ZnPgo=",u=`data:image/svg+xml;base64,${Po}`;import{getIsAndroid as zo,getIsMobile as jo}from"@binance/w3w-utils";import{useEffect as _o,useState as S}from"react";var k=()=>{let[o,n]=S(),[t,e]=S(!1);return _o(()=>{let i=jo(),r=zo();n(i),e(r)},[]),{isMobile:o,isAndroid:t}};import a from"react";import{useCallback as wn}from"react";var M=["en","ar","bg-BG","zh-CN","zh-TW","cs-CZ","fr-FR","de-DE","el-GR","id-ID","it-IT","kk-KZ","lv-LV","pl-PL","pt-BR","pt-PT","ro-RO","ru-RU","sk-SK","sl-SI","es-LA","es-ES","sv-SE","tr-TR","uk-UA","vi-VN","da-DK","my-MM","lo-LA","si-LK"];var D={"sdk-download-android":"\u062A\u0646\u0632\u064A\u0644 \u0644\u0646\u0638\u0627\u0645 Android","sdk-connect":"\u0627\u062A\u0635\u0627\u0644","sdk-download-ios":"\u062A\u0646\u0632\u064A\u0644 \u0644\u0646\u0638\u0627\u0645 iOS","sdk-install":"\u062A\u062B\u0628\u064A\u062A","sdk-modal-instruct-1":"1. \u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Binance","sdk-modal-instruct-2":"2. \u0627\u0636\u063A\u0637 {{icon}} \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629","sdk-modal-title":"\u0627\u0644\u0631\u0628\u0637 \u0645\u0639 Binance (\u0628\u064A\u0646\u0627\u0646\u0633)","sdk-no-app":"\u0644\u064A\u0633 \u0644\u062F\u064A\u0643 \u062A\u0637\u0628\u064A\u0642 Binance \u062D\u062A\u0651\u0649 \u0627\u0644\u0622\u0646\u061F"};var L={"sdk-download-android":"\u0418\u0437\u0442\u0435\u0433\u043B\u044F\u043D\u0435 \u0437\u0430 Android","sdk-connect":"\u0421\u0432\u044A\u0440\u0436\u0438","sdk-download-ios":"\u0418\u0437\u0442\u0435\u0433\u043B\u044F\u043D\u0435 \u0437\u0430 iOS","sdk-install":"\u0418\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u043D\u0435","sdk-modal-instruct-1":"1. \u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E Binance","sdk-modal-instruct-2":"2. \u0414\u043E\u043A\u043E\u0441\u043D\u0435\u0442\u0435 {{icon}} \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u043D\u0438\u044F \u0435\u043A\u0440\u0430\u043D","sdk-modal-title":"\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441\u0435 \u0441 Binance","sdk-no-app":"\u0412\u0441\u0435 \u043E\u0449\u0435 \u043D\u044F\u043C\u0430\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E Binance?"};var N={"sdk-download-android":"St\xE1hnout pro Android","sdk-connect":"P\u0159ipojit","sdk-download-ios":"St\xE1hnout pro iOS","sdk-install":"Instalovat","sdk-modal-instruct-1":"1. Otev\u0159ete aplikaci Binance","sdk-modal-instruct-2":"2. Klepn\u011Bte na {{icon}} na domovsk\xE9 obrazovce","sdk-modal-title":"P\u0159ipojit platformu Binance","sdk-no-app":"Je\u0161t\u011B nem\xE1te aplikaci Binance?"};var T={"sdk-download-android":"Download til Android","sdk-connect":"Forbind","sdk-download-ios":"Download til iOS","sdk-install":"Installer","sdk-modal-instruct-1":"1. \xC5bn Binance-appen","sdk-modal-instruct-2":"2. Tryk p\xE5 {{icon}} p\xE5 startsk\xE6rmen","sdk-modal-title":"Forbind til Binance","sdk-no-app":"Har du ikke Binance-appen endnu?"};var O={"sdk-download-android":"F\xFCr Android herunterladen","sdk-connect":"Verbinden","sdk-download-ios":"F\xFCr iOS herunterladen","sdk-install":"Installieren","sdk-modal-instruct-1":"1. Binance-App \xF6ffnen","sdk-modal-instruct-2":"2. Tippe auf dem Startbildschirm auf {{icon}}","sdk-modal-title":"Mit Binance verkn\xFCpfen","sdk-no-app":"Du hast die Binance-App noch nicht?"};var E={"sdk-download-android":"\u039B\u03AE\u03C8\u03B7 \u03B3\u03B9\u03B1 Android","sdk-connect":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5","sdk-download-ios":"\u039B\u03AE\u03C8\u03B7 \u03B3\u03B9\u03B1 iOS","sdk-install":"\u0395\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","sdk-modal-instruct-1":"1. \u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Binance","sdk-modal-instruct-2":"2. \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 {{icon}} \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE \u03BF\u03B8\u03CC\u03BD\u03B7","sdk-modal-title":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B5 \u03C4\u03B7\u03BD Binance","sdk-no-app":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B1\u03BA\u03CC\u03BC\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Binance;"};var P={"sdk-download-android":"Download for Android","sdk-connect":"Connect","sdk-download-ios":"Download for iOS","sdk-install":"Install","sdk-modal-instruct-1":"1. Open Binance app","sdk-modal-instruct-2":"2. Tap {{icon}} on Home Screen","sdk-modal-title":"Connect With Binance","sdk-no-app":"Don\u2019t have the Binance app yet?"};var z={"sdk-download-android":"Descargar para Android","sdk-connect":"Conectar","sdk-download-ios":"Descargar para iOS","sdk-install":"Instalar","sdk-modal-instruct-1":"1. Open Binance app","sdk-modal-instruct-2":"2. Pulsa en {{icon}} en la p\xE1gina principal","sdk-modal-title":"Connect With Binance","sdk-no-app":"\xBFA\xFAn no tienes la aplicaci\xF3n de Binance?"};var j={"sdk-download-android":"Descargar para Android","sdk-connect":"Conecta","sdk-download-ios":"Descargar para iOS","sdk-install":"Instala","sdk-modal-instruct-1":"1. Abre la aplicaci\xF3n de Binance","sdk-modal-instruct-2":"2. Toca {{icon}} en la pantalla de inicio","sdk-modal-title":"Conectar con Binance","sdk-no-app":"\xBFA\xFAn no tienes la aplicaci\xF3n de Binance?"};var _={"sdk-download-android":"T\xE9l\xE9charger pour Android","sdk-connect":"Se connecter","sdk-download-ios":"T\xE9l\xE9charger pour iOS","sdk-install":"Installer","sdk-modal-instruct-1":"1. Ouvrez l\u2019application de Binance","sdk-modal-instruct-2":"2. Appuyez sur {{icon}} sur l\u2019\xE9cran d\u2019accueil","sdk-modal-title":"Se connecter \xE0 Binance","sdk-no-app":"Vous n\u2019avez pas encore l\u2019application de Binance\xA0?"};var H={"sdk-download-android":"Unduh untuk Android","sdk-connect":"Terhubung","sdk-download-ios":"Unduh untuk iOS","sdk-install":"Instal","sdk-modal-instruct-1":"1. Buka aplikasi Binance","sdk-modal-instruct-2":"2. Ketuk {{icon}} di Layar Beranda","sdk-modal-title":"Hubungkan dengan Binance","sdk-no-app":"Belum punya aplikasi Binance?"};var W={"sdk-download-android":"Scarica per Android","sdk-connect":"Collega","sdk-download-ios":"Scarica per iOS","sdk-install":"Installa","sdk-modal-instruct-1":"1. Apri l'app Binance","sdk-modal-instruct-2":"2. Tocca {{icon}} nella homepage","sdk-modal-title":"Collega con Binance","sdk-no-app":"Non hai ancora l'app Binance?"};var F={"sdk-download-android":"Android \u04AF\u0448\u0456\u043D \u0436\u04AF\u043A\u0442\u0435\u043F \u0430\u043B\u0443","sdk-connect":"\u049A\u043E\u0441\u044B\u043B\u0443","sdk-download-ios":"iOS \u04AF\u0448\u0456\u043D \u0436\u04AF\u043A\u0442\u0435\u043F \u0430\u043B\u0443","sdk-install":"\u041E\u0440\u043D\u0430\u0442\u0443","sdk-modal-instruct-1":"1. Binance \u049B\u043E\u043B\u0434\u0430\u043D\u0431\u0430\u0441\u044B\u043D \u0430\u0448\u044B\u04A3\u044B\u0437","sdk-modal-instruct-2":"2. \u0411\u0430\u0441\u0442\u044B \u044D\u043A\u0440\u0430\u043D\u0434\u0430\u0493\u044B {{icon}} \u0431\u0435\u043B\u0433\u0456\u0448\u0435\u0441\u0456\u043D \u0442\u04AF\u0440\u0442\u0456\u04A3\u0456\u0437","sdk-modal-title":"Binance \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u0441\u044B\u043C\u0435\u043D \u0431\u0430\u0439\u043B\u0430\u043D\u044B\u0441\u0442\u044B\u0440\u0443","sdk-no-app":"\u0421\u0456\u0437\u0434\u0435 \u04D9\u043B\u0456 Binance \u049B\u043E\u043B\u0434\u0430\u043D\u0431\u0430\u0441\u044B \u0436\u043E\u049B \u043F\u0430?"};var V={"sdk-download-android":"\u0E94\u0EB2\u0EA7\u0EC2\u0EAB\u0EBC\u0E94\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A Android","sdk-connect":"\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8","sdk-download-ios":"\u0E94\u0EB2\u0EA7\u0EC2\u0EAB\u0EBC\u0E94\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A iOS","sdk-install":"\u0E95\u0EB4\u0E94\u0E95\u0EB1\u0EC9\u0E87","sdk-modal-instruct-1":"1. \u0EC0\u0E9B\u0EB5\u0E94\u0EC1\u0EAD\u0EB1\u0E9A Binance","sdk-modal-instruct-2":"2. \u0EC1\u0E95\u0EB0 {{icon}} \u0EC3\u0E99\u0EDC\u0EC9\u0EB2\u0E88\u0ECD\u0EAB\u0EBC\u0EB1\u0E81","sdk-modal-title":"\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8\u0E81\u0EB1\u0E9A Binance","sdk-no-app":"\u0E8D\u0EB1\u0E87\u0E9A\u0ECD\u0EC8\u0EA1\u0EB5\u0EC1\u0EAD\u0EB1\u0E9A Binance \u0EC0\u0E97\u0EB7\u0EC8\u0EAD\u0E9A\u0ECD?"};var Z={"sdk-download-android":"Lejupiel\u0101d\u0113t Android ier\u012Bcei","sdk-connect":"Savienot","sdk-download-ios":"Lejupiel\u0101d\u0113t iOS ier\u012Bcei","sdk-install":"Instal\u0113t","sdk-modal-instruct-1":"1.\xA0Atver Binance lietotni","sdk-modal-instruct-2":"2.\xA0Pieskaries pie {{icon}} s\u0101kuma ekr\u0101n\u0101","sdk-modal-title":"Savieno ar Binance","sdk-no-app":"Vai tev v\u0113l nav Binance lietotnes?"};var U={"sdk-download-android":"\u1021\u1014\u103A\u1038\u1012\u101B\u103D\u102D\u102F\u1000\u103A\u1021\u1010\u103D\u1000\u103A \u1012\u1031\u102B\u1004\u103A\u1038\u101C\u102F\u1012\u103A\u101C\u102F\u1015\u103A\u1019\u100A\u103A","sdk-connect":"\u1001\u103B\u102D\u1010\u103A\u1006\u1000\u103A\u1019\u100A\u103A","sdk-download-ios":"iOS \u1021\u1010\u103D\u1000\u103A \u1012\u1031\u102B\u1004\u103A\u1038\u101C\u102F\u1012\u103A\u101C\u102F\u1015\u103A\u1019\u100A\u103A","sdk-install":"\u1011\u100A\u1037\u103A\u101E\u103D\u1004\u103A\u1038\u1019\u100A\u103A","sdk-modal-instruct-1":"1. Open Binance app","sdk-modal-instruct-2":"\u1015\u1004\u103A\u1019\u1019\u103B\u1000\u103A\u1014\u103E\u102C\u1015\u103C\u1004\u103A\u1019\u103E {{icon}} \u1000\u102D\u102F\u1014\u103E\u102D\u1015\u103A\u1015\u102B\u104B","sdk-modal-title":"Connect With Binance","sdk-no-app":"Binance App \u1019\u101B\u103E\u102D\u101E\u1031\u1038\u1018\u1030\u1038\u101C\u102C\u1038\u104B"};var Q={"sdk-download-android":"Pobierz na Androida","sdk-connect":"Po\u0142\u0105cz","sdk-download-ios":"Pobierz na iOS","sdk-install":"Zainstaluj","sdk-modal-instruct-1":"1. Otw\xF3rz Aplikacj\u0119 Binance","sdk-modal-instruct-2":"2. Kliknij {{icon}} na ekranie g\u0142\xF3wnym","sdk-modal-title":"Po\u0142\u0105cz z Binance","sdk-no-app":"Nie masz jeszcze aplikacji Binance?"};var G={"sdk-download-android":"Baixar para Android","sdk-connect":"Conecte","sdk-download-ios":"Baixar para iOS","sdk-install":"Instalar","sdk-modal-instruct-1":"1. Abra o Aplicativo da Binance","sdk-modal-instruct-2":"2. Toque em {{icon}} na Tela Inicial","sdk-modal-title":"Conectar com a Binance","sdk-no-app":"Ainda n\xE3o tem o aplicativo da Binance?"};var Y={"sdk-download-android":"Transferir para Android","sdk-connect":"Associar","sdk-download-ios":"Transferir para iOS","sdk-install":"Instalar","sdk-modal-instruct-1":"1. Abre a aplica\xE7\xE3o Binance","sdk-modal-instruct-2":"2. Toca em {{icon}} no Ecr\xE3 Inicial","sdk-modal-title":"Associa com a Binance","sdk-no-app":"Ainda n\xE3o tens a aplica\xE7\xE3o Binance?"};var K={"sdk-download-android":"Desc\u0103rca\u021Bi pentru Android","sdk-connect":"Conectare","sdk-download-ios":"Desc\u0103rca\u021Bi pentru iOS","sdk-install":"Instala\u021Bi","sdk-modal-instruct-1":"1. Deschide\u021Bi aplica\u021Bia Binance","sdk-modal-instruct-2":"2. Atinge\u021Bi {{icon}} pe ecranul de pornire","sdk-modal-title":"Conecta\u021Bi-v\u0103 cu Binance","sdk-no-app":"Nu ave\u021Bi \xEEnc\u0103 aplica\u021Bia Binance?"};var J={"sdk-download-android":"\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0434\u043B\u044F Android","sdk-connect":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C","sdk-download-ios":"\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0434\u043B\u044F iOS","sdk-install":"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C","sdk-modal-instruct-1":"1. \u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Binance","sdk-modal-instruct-2":"2. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 {{icon}} \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435","sdk-modal-title":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A Binance","sdk-no-app":"\u0423 \u0432\u0430\u0441 \u0435\u0449\u0435 \u043D\u0435\u0442 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F Binance?"};var R={"sdk-download-android":"Android \u0DC3\u0DB3\u0DC4\u0DCF \u0DB6\u0DCF\u0D9C\u0DAD \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-connect":"\u0DC3\u0DB8\u0DCA\u0DB6\u0DB1\u0DCA\u0DB0 \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-download-ios":"iOS \u0DC3\u0DB3\u0DC4\u0DCF \u0DB6\u0DCF\u0D9C\u0DAD \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-install":"\u0DC3\u0DCA\u0DAE\u0DCF\u0DB4\u0DB1\u0DBA \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-modal-instruct-1":"1. Binance \u0DBA\u0DD9\u0DAF\u0DD4\u0DB8 \u0DC0\u0DD2\u0DC0\u0DD8\u0DAD \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-modal-instruct-2":"2. \u0DB8\u0DD4\u0DBD\u0DCA \u0DAD\u0DD2\u0DBB\u0DBA\u0DDA {{icon}} \u0DB8\u0DAD \u0DAD\u0DA7\u0DCA\u0DA7\u0DD4 \u0D9A\u0DBB\u0DB1\u0DCA\u0DB1","sdk-modal-title":"Binance \u0DC3\u0DB8\u0D9C \u0DC3\u0DB8\u0DCA\u0DB6\u0DB1\u0DCA\u0DB0 \u0DC0\u0DB1\u0DCA\u0DB1","sdk-no-app":"\u0DAD\u0DC0\u0DB8\u0DAD\u0DCA Binance \u0DBA\u0DD9\u0DAF\u0DD4\u0DB8 \u0DB1\u0DD0\u0DAD\u0DD2 \u0DAF?"};var $={"sdk-download-android":"Stiahnu\u0165 pre Android","sdk-connect":"Pripoji\u0165","sdk-download-ios":"Stiahnu\u0165 pre iOS","sdk-install":"Nain\u0161talova\u0165","sdk-modal-instruct-1":"1. Otvorte aplik\xE1ciu Binance","sdk-modal-instruct-2":"2. Klepnite na ikonu {{icon}} na domovskej obrazovke","sdk-modal-title":"Spojte sa s\xA0Binance","sdk-no-app":"E\u0161te nem\xE1te aplik\xE1ciu Binance?"};var X={"sdk-download-android":"Prenos za Android","sdk-connect":"Pove\u017Ei","sdk-download-ios":"Prenos za iOS","sdk-install":"Namesti","sdk-modal-instruct-1":"1. Odprite aplikacijo Binance","sdk-modal-instruct-2":"2. Tapnite {{icon}} na za\u010Detnem zaslonu","sdk-modal-title":"Pove\u017Eite se s platformo Binance","sdk-no-app":"\u0160e nimate aplikacije Binance?"};var q={"sdk-download-android":"Ladda ned f\xF6r Android","sdk-connect":"Anslut","sdk-download-ios":"Ladda ned f\xF6r iOS","sdk-install":"Installera","sdk-modal-instruct-1":"1. \xD6ppna Binance-appen","sdk-modal-instruct-2":"2. Tryck p\xE5 {{icon}} p\xE5 startsk\xE4rmen","sdk-modal-title":"Anslut med Binance","sdk-no-app":"Har du inte Binance-appen \xE4nnu?"};var oo={"sdk-download-android":"Android i\xE7in indir","sdk-connect":"Ba\u011Flan","sdk-download-ios":"iOS i\xE7in indir","sdk-install":"Y\xFCkle","sdk-modal-instruct-1":"1. Binance Uygulamas\u0131n\u0131 A\xE7\u0131n","sdk-modal-instruct-2":"2. Ana Ekranda {{icon}} simgesine dokunun","sdk-modal-title":"Binance ile Ba\u011Flan\u0131n","sdk-no-app":"Hen\xFCz Binance uygulaman\u0131z yok mu?"};var no={"sdk-download-android":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043B\u044F Android","sdk-connect":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044C","sdk-download-ios":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043B\u044F iOS","sdk-install":"\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438","sdk-modal-instruct-1":"1. \u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043E\u043A Binance","sdk-modal-instruct-2":"2. \u0422\u043E\u0440\u043A\u043D\u0456\u0442\u044C\u0441\u044F {{icon}} \u043D\u0430 \u0433\u043E\u043B\u043E\u0432\u043D\u043E\u043C\u0443 \u0435\u043A\u0440\u0430\u043D\u0456","sdk-modal-title":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C\u0441\u044F \u0434\u043E Binance","sdk-no-app":"\u0429\u0435 \u043D\u0435 \u043C\u0430\u0454\u0442\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443 Binance?"};var to={"sdk-download-android":"T\u1EA3i xu\u1ED1ng cho Android","sdk-connect":"K\u1EBFt n\u1ED1i","sdk-download-ios":"T\u1EA3i xu\u1ED1ng cho iOS","sdk-install":"C\xE0i \u0111\u1EB7t","sdk-modal-instruct-1":"1. M\u1EDF \u1EE9ng d\u1EE5ng Binance","sdk-modal-instruct-2":"2. Nh\u1EA5n v\xE0o {{icon}} tr\xEAn M\xE0n h\xECnh ch\xEDnh","sdk-modal-title":"K\u1EBFt n\u1ED1i v\u1EDBi Binance","sdk-no-app":"B\u1EA1n ch\u01B0a c\xF3 \u1EE9ng d\u1EE5ng Binance?"};var eo={"sdk-download-android":"\u4E0B\u8F7D\u5B89\u5353\u7248","sdk-connect":"\u5173\u8054","sdk-download-ios":"\u4E0B\u8F7DiOS\u7248","sdk-install":"\u5B89\u88C5","sdk-modal-instruct-1":"1.\u6253\u5F00\u5E01\u5B89App","sdk-modal-instruct-2":"2.\u70B9\u51FB\u4E3B\u5C4F\u5E55\u7684{{icon}}","sdk-modal-title":"\u5173\u8054\u5E01\u5B89","sdk-no-app":"\u5C1A\u672A\u5B89\u88C5\u5E01\u5B89App\uFF1F"};var io={"sdk-download-android":"Android \u4E0B\u8F09","sdk-connect":"\u9023\u63A5","sdk-download-ios":"iOS \u4E0B\u8F09","sdk-install":"\u5B89\u88DD","sdk-modal-instruct-1":"1. \u958B\u555F\u5E63\u5B89 App","sdk-modal-instruct-2":"2. \u5728\u9996\u9801\u756B\u9762\u4E0A\u9EDE\u64CA {{icon}}","sdk-modal-title":"\u8207\u5E63\u5B89\u9023\u63A5","sdk-no-app":"\u9084\u6C92\u6709\u5E63\u5B89 App \u55CE\uFF1F"};var ao={en:P,ar:D,"bg-BG":L,"zh-CN":eo,"zh-TW":io,"cs-CZ":N,"fr-FR":_,"de-DE":O,"el-GR":E,"id-ID":H,"it-IT":W,"kk-KZ":F,"lv-LV":Z,"pl-PL":Q,"pt-BR":G,"pt-PT":Y,"ro-RO":K,"ru-RU":J,"sk-SK":$,"sl-SI":X,"es-LA":j,"es-ES":z,"sv-SE":q,"tr-TR":oo,"uk-UA":no,"vi-VN":to,"da-DK":T,"my-MM":U,"lo-LA":V,"si-LK":R};var fn=M.reduce((o,n)=>(o[n]=ao[n],o),{}),y=fn;var hn=()=>{let{lng:o}=I();return wn((n,t)=>y?.[o]?.[n]||y?.en?.[n]||t?.default||n,[o])},l=hn;import ro from"react";import xn from"react";var bn=({size:o=24,color:n="currentColor",className:t,children:e,...i})=>xn.createElement("svg",{width:o,height:o,fill:n,className:t,viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg",...i},e),s=bn;var so=o=>ro.createElement(s,{size:24,...o},ro.createElement("path",{d:"M21.7725 18.7033C21.4062 19.5418 20.9727 20.3136 20.4704 21.0232C19.7857 21.9906 19.2251 22.6602 18.7931 23.032C18.1233 23.6424 17.4058 23.955 16.6374 23.9728C16.0857 23.9728 15.4205 23.8172 14.6461 23.5017C13.8692 23.1876 13.1552 23.032 12.5024 23.032C11.8177 23.032 11.0834 23.1876 10.2979 23.5017C9.51127 23.8172 8.87756 23.9816 8.39305 23.9979C7.65619 24.0291 6.92173 23.7076 6.1886 23.032C5.72069 22.6276 5.13542 21.9343 4.43429 20.9521C3.68203 19.9033 3.06358 18.687 2.57906 17.3004C2.06017 15.8026 1.80005 14.3523 1.80005 12.9482C1.80005 11.3398 2.15076 9.95259 2.85324 8.79011C3.40532 7.85636 4.13979 7.11979 5.05903 6.57906C5.97827 6.03834 6.97151 5.76279 8.04114 5.74516C8.62641 5.74516 9.39391 5.92456 10.3477 6.27715C11.2988 6.63091 11.9095 6.81032 12.1772 6.81032C12.3774 6.81032 13.0558 6.60054 14.2058 6.18233C15.2934 5.79449 16.2113 5.63391 16.9633 5.69716C19.0009 5.86012 20.5317 6.6561 21.5497 8.09013C19.7274 9.18432 18.826 10.7169 18.8439 12.6829C18.8603 14.2142 19.4209 15.4886 20.5227 16.5004C21.022 16.97 21.5796 17.333 22.2001 17.5907C22.0655 17.9774 21.9235 18.3477 21.7725 18.7033ZM17.0993 0.480137C17.0993 1.68041 16.6568 2.8011 15.7748 3.8384C14.7104 5.07155 13.4229 5.78412 12.0268 5.67168C12.009 5.52769 11.9987 5.37614 11.9987 5.21688C11.9987 4.06462 12.5049 2.83147 13.4038 1.82321C13.8526 1.3127 14.4234 0.888228 15.1155 0.549615C15.8062 0.216055 16.4595 0.031589 17.0739 0C17.0918 0.160458 17.0993 0.320926 17.0993 0.480121V0.480137Z",fill:"#1E2329"}));import m from"react";var lo=o=>m.createElement(s,{size:24,...o},m.createElement("path",{d:"M13.5589 11.0874L4.08203 1.59644H4.17441C4.98558 1.59644 5.68614 1.89129 6.81073 2.4993L16.7488 7.88083L13.5589 11.0874Z",fill:"#202630"}),m.createElement("path",{d:"M12.6373 12.008L2.90218 21.7203C2.66236 21.3329 2.49658 20.7063 2.49658 19.8034V4.19354C2.49658 3.29078 2.66236 2.66403 2.90218 2.2771L12.6373 12.008Z",fill:"#202630"}),m.createElement("path",{d:"M13.5589 12.9124L16.7488 16.1187L6.81073 21.5001C5.68614 22.1083 4.98548 22.4036 4.17441 22.4036H4.08203L13.5589 12.9124Z",fill:"#202630"}),m.createElement("path",{d:"M17.9437 8.52563L14.4775 12.0091L17.9437 15.4738L20.0456 14.3309C20.8199 13.9069 22 13.1329 22 12.0091C22 10.8662 20.8199 10.0922 20.0456 9.66821L17.9437 8.52563Z",fill:"#202630"}));import co from"react";var po=o=>co.createElement(s,{size:24,...o},co.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7.5 4H10.5V7H7.5V10H4.5V7V4H7.5ZM14.5 4H17.5H20.5V7V10H17.5V7H14.5V4ZM10.5 20V17H7.5V14H4.5V17V20H7.5H10.5ZM17.5 20H14.5V17H17.5V14H20.5V17V20H17.5ZM16.5 10.5H8.5V13.5H16.5V10.5Z",fill:"#202630"}));import B from"react";var mo=({value:o,...n})=>{let e=vn(o).map(i=>typeof i=="string"?i:B.cloneElement(n[i.key],{key:i.key}));return B.createElement(B.Fragment,null,e)},vn=o=>{let n=/{{(.*?)}}/g,t,e=0,i=[];for(;(t=n.exec(o))!==null;)t.index!==e&&i.push(o.substring(e,t.index)),i.push({key:t[1]}),e=n.lastIndex;return e!==o.length&&i.push(o.substring(e)),i};var ko=()=>{let o=l();return a.createElement(a.Fragment,null,a.createElement(yn,{t:o}),a.createElement(Bn,{t:o}),a.createElement(Cn,null))},yn=({t:o})=>a.createElement("div",{style:{borderBottom:"1px solid #EAECEF"},className:"grid justify-center gap-y-2 pb-6 body3 t-black border-b border-gray-300"},a.createElement("div",null,o("sdk-modal-instruct-1",{default:"1. Open Binance app"})),a.createElement("div",{className:"flex items-center"},a.createElement(mo,{value:o("sdk-modal-instruct-2",{default:"2. Tap {{icon}} on Home"}),icon:a.createElement(po,{className:"w-[24px] h-[24px] mx-[4px]"})}))),Bn=({t:o})=>a.createElement("div",{className:"py-4 body3 t-secondary text-center"},o("sdk-no-app",{default:"Don't have Binance app yet?"})),Cn=()=>a.createElement("div",{className:"grid grid-cols-2 gap-x-4"},a.createElement(uo,{type:"iOS"}),a.createElement(uo,{type:"Android"})),uo=({type:o})=>{let n=l();return a.createElement("div",{style:{border:"1px solid #EAECEF"},className:"p-[12px] rounded-lg grid cursor-pointer t-secondary grid-flow-col items-center gap-x-4 w-[150px]",onClick:()=>{window.open(o==="Android"?v.googlePlay:v.appleStore,"_blank")}},o==="Android"?a.createElement(lo,{className:"w-[24px] h-[24px] m-auto"}):a.createElement(so,{className:"w-[24px] h-[24px] m-auto"}),a.createElement("div",{className:"w-[75px] caption2 t-secondary"},n(`sdk-download-${o.toLowerCase()}`,{default:`Download for ${o}`})))};import f from"react";import go from"react";var g=o=>go.createElement(s,{...o},go.createElement("path",{d:"M6.69708 4.57538L4.57576 6.6967L9.87906 12L4.57576 17.3033L6.69708 19.4246L12.0004 14.1213L17.3037 19.4246L19.425 17.3033L14.1217 12L19.425 6.6967L17.3037 4.57538L12.0004 9.87868L6.69708 4.57538Z",fill:"currentColor"}));var An=({onClose:o})=>{let n=l();return f.createElement("div",{className:"flex items-center justify-between"},f.createElement("p",{className:"text-base font-medium text-[#1E2329] lg:text-xl md:font-semibold md:subtitle1"},n("sdk-modal-title",{default:"Connect with Binance"})),f.createElement("div",{className:"cursor-pointer text-[#929AA5]",onClick:o},f.createElement(g,null)))},fo=An;import d from"react";var wo=({id:o,onClose:n,onConnect:t})=>{let e=l();return d.createElement("div",{id:o,className:"animated fadeIn pointer-events-auto fixed top-0 left-0 h-full w-full bg-black/[.80] duration-300 ease-in-out will-change-auto"},d.createElement("div",{className:"absolute bottom-0 m-auto w-full rounded-t-2xl bg-white px-4 pb-6 shadow-inner duration-300 ease-in-out will-change-transform md:w-[400px]"},d.createElement(In,{onClose:n}),d.createElement("div",{className:"mt-6 mb-4 flex justify-center"},d.createElement("img",{className:"w-[60px]",src:u})),d.createElement("div",{className:"subtitle1 text-center mb-6 t-primary"},e("sdk-modal-title",{default:"Connect with Binance"})),d.createElement("button",{onClick:t,style:{borderColor:"transparent"},className:"w-full rounded h-[40px] flex justify-center items-center bg-primary t-primary subtitle3 mb-4"},e("sdk-connect",{default:"Connect"})),d.createElement("div",{className:"text-center py-3"},d.createElement("span",null,e("sdk-no-app",{default:"Don\u2019t have Binance app yet?"})),d.createElement("a",{target:"_blank",href:"https://www.binance.com/en/download",className:"t-brand ml-1"},e("sdk-install",{default:"Install"})))))},In=({onClose:o})=>d.createElement("div",{className:"flex items-center justify-end h-[52px]"},d.createElement("div",{className:"cursor-pointer text-[#929AA5]",onClick:o},d.createElement(g,{className:"w-[20px]"})));import{QRCodeSVG as Ln}from"qrcode.react";import w from"react";import{getHref as Sn}from"@binance/w3w-utils";var Mn=(o,n)=>{let t="visibilitychange",e=setTimeout(()=>{document.hidden||o()},n),i=()=>{document.hidden&&(clearTimeout(e),document.removeEventListener(t,i))};document.addEventListener(t,i,!1)},Dn=o=>{let n=document.createElement("a");n.href=o,document.body.appendChild(n),Mn(()=>{window.location.href="https://www.binance.com/en/download"},1e3),n.click(),document.body.removeChild(n)},ho=o=>{let{isAndroid:n,isMobile:t}=k();return{toBinance:()=>{let i=Sn(n,o);if(t){if(!n){let r=document.createElement("a");r.href=i,document.body.appendChild(r),r.click(),document.body.removeChild(r)}n&&Dn(i)}}}};function Nn(o){let{toBinance:n}=ho(o.url);return w.createElement("div",null,w.createElement("div",{className:"mt-[35px] flex justify-center"},w.createElement("div",{className:"w-[200px] h-[200px] mb-4",onClick:n},o.url&&w.createElement(Ln,{value:o.url,width:"100%",height:"100%",level:"M",imageSettings:{src:u,height:32,width:32,excavate:!1}}))))}var xo=Nn;var En=({onClose:o,isReady:n})=>{let{isMobile:t}=k(),[e,i]=bo(""),[r,Lo]=bo(!1);On(()=>{n.then(i).catch(()=>Lo(!0))},[n]);let No=()=>{Tn(e)},To={url:e,error:r};if(t===!1)return c.createElement("div",{id:p,className:"animated fadeIn pointer-events-auto fixed top-0 left-0 h-full w-full bg-black/[.80] duration-300 ease-in-out will-change-auto"},c.createElement("div",{className:"relative top-2/4 m-auto w-[343px] translate-y-[-50%] rounded-2xl bg-white px-6 pt-[20px] pb-6 shadow-inner duration-300 ease-in-out will-change-transform md:w-[400px] lg:p-8 lg:pt-6"},c.createElement(fo,{onClose:o}),c.createElement(xo,{...To}),c.createElement(ko,null)));if(t)return c.createElement(wo,{onConnect:No,onClose:o,id:p})},vo=En;var yo={order:["querystring","cookie","localStorage","sessionStorage","navigator","htmlTag","path","subdomain"],lookupQuerystring:function(){let o=window.location.search.match(/lng=([^&]*)/);return o&&o[1]},lookupCookie:function(){let o=document.cookie.match(/i18next=([^;]*)/);return o&&o[1]},lookupLocalStorage:function(){return localStorage.getItem("i18nextLng")},lookupSessionStorage:function(){return sessionStorage.getItem("i18nextLng")},lookupFromNavigator:function(){return navigator.language},lookupFromHtmlTag:function(){return document.documentElement.lang},lookupFromPath:function(){let o=window.location.pathname.match(/\/([^/]*)/);return o&&o[1]},lookupFromSubdomain:function(){let o=window.location.hostname.match(/^(.+)\./);return o&&o[1]}},Bo=()=>{for(let o of yo.order)try{let n=yo["lookup"+o.charAt(0).toUpperCase()+o.slice(1)]();if(n)return n}catch(n){console.error(`Error detecting language with method: ${o}`,n);continue}return"en"};function jn(){let o=window.document,n=o.createElement("div");return n.setAttribute("id",b),o.body.appendChild(n),n}function Co(){let o=window.document,n=o.getElementById(p);n&&(n.className=n.className.replace("fadeIn","fadeOut"),setTimeout(()=>{let t=o.getElementById(b);t&&o.body.removeChild(t)},300))}function _n(o){return()=>{Co(),o&&o()}}async function Ao({isReady:o,cb:n,lng:t}){let e=jn(),i=zn(e);await o;let r=t??Bo();i.render(h.createElement(x.Provider,{value:{lng:r}},h.createElement("style",{dangerouslySetInnerHTML:{__html:A}}),h.createElement(vo,{isReady:o,onClose:_n(n)})))}function Io(){Co()}var Mo=o=>{},Do=()=>{};function Wn({cb:o,lng:n}){let t=new Promise((e,i)=>{Mo=e,Do=i});So()||Ao({isReady:t,cb:o,lng:n})}function Fn(){So()||Io()}function Vn(o){Mo(o)}function Zn(){console.log("relay failed...."),Do()}var Un={open:Wn,close:Fn,ready:Vn,fail:Zn},Ci=Un;export{Ci as default};
//# sourceMappingURL=index.js.map